<template>
  <v-card class="result_card" > <!--  v-bind="bind_selected" -->
    <v-layout row wrap>
      <v-flex xs12 md6 lg6 >
        <v-card-title primary-title>
          <div>
            <div class="result_title_star subheading primary--text" >
              <result-checkbox :result="result"></result-checkbox>
              <ais-highlight  :result="result" attribute-name="title"></ais-highlight>
            </div>
            <div class='caption'>Published: <strong>{{ format(fromUnixTime(result['publishDate']), 'yyyy-MM-dd') }}</strong></div>
            <div>
              <p class="snippet" v-html="result._snippetResult.text && result._snippetResult.text.value + '...'"/>
            </div>
          </div>
        </v-card-title>
      </v-flex>
      <v-flex xs12 md6 lg6 >
        <v-layout row style="padding-bottom:8px;">
          <v-flex xs7>
            <!-- Buttons zone-->
            <v-btn small slot="activator" class="primary white--text" :disabled="hideShowMoreBtn"
              @click.native="showMore(result)">
              <v-icon dark class="btn_icone">far fa-eye</v-icon>
              Show more
            </v-btn>
            <v-btn small slot="activator" class="primary white--text"
              target="_blank" :href="result.url" @click.native="onClickOpen('click-open', result.objectID, result.title)">
              <v-icon dark class="btn_icone">open_in_new</v-icon>
              Open
            </v-btn>
          </v-flex>
          <v-flex xs5>
            <v-img class="source_img" contain :src="result.sourceLogo && attachment_path + result.sourceLogo" />
          </v-flex>
        </v-layout>
<!--         <v-layout row style="padding-bottom:8px; padding-left:8px; padding-right:8px;"
          v-if="user && user.access_right[algolia_articles_index_name]['show_tag'] == true"> -->
          <v-layout row style="padding-bottom:8px; padding-left:8px; padding-right:8px;">
          <v-flex xs12>
            <v-layout row v-show="region">
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="orange" slot="activator">map</v-icon>
                  <span>Region / Country / City / Airport</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 4px;margin-left: 8px;">
                <span v-html="region"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="retailAndBrand" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="blue" slot="activator">shopping_cart</v-icon>
                  <span>Retailer | Related actors</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-html="retailAndBrand"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="supplierAndBrand" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="light-green" slot="activator">work</v-icon>
                  <span>Supplier | Brand</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-html="supplierAndBrand"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="category" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="red" slot="activator">list</v-icon>
                  <span>Category</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-html="category"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="smartTags" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="purple" slot="activator">local_offer</v-icon>
                  <span>Smart tags</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 4px;margin-left: 8px;">
                <span v-html="smartTags"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="isMustRead" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="#f6a200" slot="activator">star</v-icon>
                  <span>Must read</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 4px;margin-left: 8px; color:#f6a200;">
                <strong>Must Read</strong>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import resultPanelConstructor from '../ResultPanelConstructor'
import LOGGER from '@/graphql/Logger.gql'
import USER from '@/graphql/User.gql'
import DEMO_USER from '@/graphql/DemoUser.gql'
import { mapMutations } from 'vuex'

export default {
  name: 'press-result-panel',
  extends: resultPanelConstructor,
  data () {
    return {
      user: false,
      demoUser: false,
      attachment_path: process.env.VUE_APP_ATTACHMENT_PATH,
      algolia_articles_index_name: process.env.VUE_APP_ALGOLIA_ARTICLES_INDEX_NAME,
      format,
      fromUnixTime
    }
  },
  methods: {
    ...mapMutations('documentForm', ['setDocumentId', 'setViewedDocument', 'setViewedDocumentDialog']),
    onClickOpen (action, objectId, title) {
      this.$apollo.mutate({
        mutation: LOGGER,
        variables: {
          level: 'info',
          message: JSON.stringify({
            module: this.$route.name,
            action,
            objectId,
            title
          })
        }
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    },
    async showMore (result) {
      this.setDocumentId(result.objectID)
      await this.setViewedDocument(result)
      this.setViewedDocumentDialog(true)
      this.onClickOpen('click-showmore', result.objectID, result.title)
    }
  },
  computed: {
    isMustRead () {
      return ('smartTags' in this.result) && !!this.result.smartTags.length && this.result.smartTags.some(x => x.n === 'Must Read')
    },

    hideShowMoreBtn () {
      // user right
      let res = false

      if (!this.user) {
        return true
      }

      if (this.user.access_right[this.algolia_articles_index_name].hide_show_more_by_source !== undefined &&
          this.user.access_right[this.algolia_articles_index_name].hide_show_more_by_source.indexOf(this.result.source) > -1) {
        res = true
      }

      // demo user right
      if (this.user.access_right[this.algolia_articles_index_name].demo &&
          this.userDemo.access_right[this.algolia_articles_index_name].hide_show_more_by_source.indexOf(this.result.source) > -1) {
        res = true
      }
      return res
    },
    region () {
      let res = ''
      if (this.result.region !== undefined && this.result.region.length > 0) {
        res += '<strong>Regions:</strong> ' + this.result.region.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.country !== undefined && this.result.country.length > 0) { res += ' - <strong>Countries:</strong> ' }
      if (this.result.country !== undefined && this.result.country.length > 0) {
        res += this.result.country.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.city !== undefined && this.result.city.length > 0) { res += ' - <strong>Cities:</strong> ' }
      if (this.result.city !== undefined && this.result.city.length > 0) {
        res += this.result.city.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.airport !== undefined && this.result.airport.length > 0) { res += ' - <strong>Airports:</strong> ' }
      if (this.result.airport !== undefined && this.result.airport.length > 0) {
        res += this.result.airport.map(v => v.n).join(', ')
      }
      return res
    },
    retailAndBrand () {
      let res = ''
      if (this.result.retailer !== undefined && this.result.retailer.length > 0) {
        res += '<strong>Retailers:</strong> ' + this.result.retailer.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.retailBrand !== undefined && this.result.retailBrand.length > 0) { res += ' - <strong>Related actors:</strong> ' }
      if (this.result.retailBrand !== undefined && this.result.retailBrand.length > 0) {
        res += this.result.retailBrand.map(v => v.n).join(', ')
      }
      return res
    },
    supplierAndBrand () {
      let res = ''
      // if (this.result.category !== undefined && this.result.category.length > 0) {
      //   res += this.result.category.map(v => v.n).join(', ')
      // }
      // if (res !== '' && this.result.company !== undefined && this.result.company.length > 0) { res += ' - ' }
      if (this.result.company !== undefined && this.result.company.length > 0) {
        res += '<strong>Companies:</strong> ' + this.result.company.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.brand !== undefined && this.result.brand.length > 0) { res += ' - <strong>Brands:</strong> ' }
      if (this.result.brand !== undefined && this.result.brand.length > 0) {
        res += this.result.brand.map(v => v.n).join(', ')
      }
      return res
    },
    category () {
      let res = ''
      if (this.result.category !== undefined && this.result.category.length > 0) {
        res += '<strong>Categories:</strong> ' + this.result.category.map(v => v.n).join(', ')
      }
      return res
    },
    smartTags () {
      if (this.result.smartTags !== undefined && this.result.smartTags.length > 0) {
        return '<strong>Smart tags:</strong> ' + this.result.smartTags.filter(v => v.n !== 'Must Read').map(v => v.n).join(', ')
      }
      return ''
    }
  },
  apollo: {
    user: {
      query: USER,
      skip () {
        return !this.$auth0.isAuthenticated()
      }
    },
    demoUser: {
      query: DEMO_USER
    }
  }
}
</script>
